import { z } from "zod";
export const EmailCaptureSyncRequestSchema = z.object({
    dryRun: z.boolean().optional().default(false),
    mailboxes: z.array(z.string().email()).optional(),
});
export const EmailCaptureSyncResultSchema = z
    .object({
    mailboxesScanned: z.number().int().nonnegative(),
    messagesSeen: z.number().int().nonnegative(),
    captured: z.number().int().nonnegative(),
    contactsCreated: z.number().int().nonnegative(),
    skippedInternal: z.number().int().nonnegative(),
    duplicates: z.number().int().nonnegative(),
})
    .passthrough();
//# sourceMappingURL=email-capture.js.map